import {Heading} from '@primer/react'

import styles from './NewViewExperience.module.css'
import NewViewGraphic from './NewViewGraphic'

export default function NewViewExperience() {
  return (
    <div className={styles.NewViewExperienceContainer}>
      <NewViewGraphic />
      <div className={styles.textContent}>
        <Heading as="h2" className={styles.Heading}>
          Build powerful views to keep track of work
        </Heading>
        <span className={styles.descriptionText}>Create your own views to quickly find and access your work.</span>
      </div>
    </div>
  )
}
